import { Refinement } from 'react-instantsearch-core';
import { RangeRefinement } from '~/features/productsList/models';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isRange = (item: any): item is RangeRefinement => {
    return typeof item === 'object' && item !== null && 'min' in item && 'max' in item;
};

export const mapAttributesToStringFilters = (items: Refinement[]) => {
    // Array of facet filters.
    // limit in algolia is 10.
    return items
        .slice(0, 10)
        .reduce<string[]>((prev, { items, currentRefinement, attribute }): string[] => {
            if (items) {
                items.forEach(({ label }) => {
                    prev.push(`${attribute}:${label}`);
                });
            }

            if (!items && isRange(currentRefinement)) {
                prev.push(`${attribute}:${currentRefinement.min}-${currentRefinement.max}`);
            }

            return prev;
        }, []);
};
